import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../../css/page-profile.css";
import { useAuth } from "../../Context/store/context";
import globals from '../../../globals';
import { IconColorSwatch, IconMapPin } from '@tabler/icons-react';


// actively using this page 2706
export default function Myaccounts() {
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const Navigate = useNavigate();
  const { logoutuser, getToken, updateTitleAndIcon } = useAuth();
  const [profileImgurl, setprofileImgurl] = useState("/images/user3.png");
  const [coverImageUrl, setCoverImageUrl] = useState("/images/bannerimg01.jpg");
  const [address, setAddress] = useState("");

  const handleuseredit = () => {
    Navigate("/profile/edit");
  };

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.profile.title, globals.profile.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      if (userDetails.profileImage) {
        setprofileImgurl(userDetails.profileImage);
      }

      if (userDetails.coverImage) {
        setCoverImageUrl(userDetails.coverImage);
      }

      buildAddress();
    }
  }, [userDetails]);

  const buildAddress = () => {
    let address = ""
    if (userDetails.addressLine1)
      address = userDetails.addressLine1;

    if (userDetails.addressLine2)
      address = address + ", " + userDetails.addressLine2;

    if (userDetails.city)
      address = address + ", " + userDetails.city;

    if (userDetails.state)
      address = address + ", " + userDetails.state;

    if (userDetails.country)
      address = address + ", " + userDetails.country;

    if (userDetails.pinCode)
      address = address + " - " + userDetails.pinCode;
    setAddress(address);
  }

  return (
    <>
      {userDetails && (
        <div className="content-wrapper">

          <div className="container-xxl flex-grow-1 container-p-y">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="user-profile-header-banner">
                    <img
                      src={coverImageUrl}
                      alt="Banner image"
                      className="rounded-top"
                    />
                  </div>
                  <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                    <div
                      className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto"
                      style={{ display: "flex" }}
                    >
                      <img
                        src={profileImgurl}
                        alt="user image"
                        className="d-block  ms-0 ms-sm-4 rounded user-profile-img"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div className="flex-grow-1 mt-3 mt-sm-5">
                      <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                        <div className="user-profile-info">
                          <h4>{userDetails.firstName} {userDetails.lastName}</h4>

                          <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                            {userDetails.tagLine &&
                              userDetails.tagLine.trim() !== "" && (
                                <li className="list-inline-item d-flex gap-1">
                                  <IconColorSwatch className="me-1" size={20}/>{userDetails.tagLine}
                                </li>
                              )}
                            {address &&
                              address.trim() !== "" && (
                                <li className="list-inline-item d-flex gap-1">
                                  <IconMapPin className="me-1" size={20}/>{address}
                                </li>
                              )}
                          </ul>
                        </div>
                        <a
                          className="btn btn-primary waves-effect waves-light text-white"
                          onClick={handleuseredit}
                        >
                          Edit Profile
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card mb-4">
                  <div className="card-body">
                    <h5 className="card-header px-0 py-3">Personal Details</h5>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="row mb-4">
                          <label className="col-lg-4 fw-semibold text-muted">
                            Contact Number
                          </label>
                          <div className="col-lg-8">
                            <span className="fw-bold fs-6 text-gray-800">
                              {userDetails.contactNo}
                            </span>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <label className="col-lg-4 fw-semibold text-muted">
                            Email Address
                          </label>
                          <div className="col-lg-8">
                            <span className="fw-bold fs-6 text-gray-800"> {userDetails.email}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="row mb-4">
                          <label className="col-lg-4 fw-semibold text-muted">
                            Date of Birth
                          </label>
                          <div className="col-lg-8">
                            <span className="fw-bold fs-6 text-gray-800">
                              {userDetails.formattedDob}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
